<template>
  <img
    v-if="src"
    :src="src"
    :alt="alt"
    :srcset="srcset"
  >
</template>

<script>
  import { fetchImage } from '@/api/media';

  export default {
    props: {
      id: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        src: undefined,
        alt: undefined,
        srcset: undefined,
      };
    },
    watch: {
      id: 'fetch',
    },
    created() {
      this.fetch();
    },
    methods: {
      cleanSrcset(srcset) {
        if (!srcset) {
          return null;
        }

        const matches = srcset.match(/srcset="(.*?)"/);

        if (!matches) {
          return null;
        }

        return matches[1];

        // return Object
        //   .values(srcset)
        //   .map(({ source_url: src, width }) => `${src} ${width}w`)
        //   .join(', ');
      },
      clean({
        alt_text: alt,
        source_url: src,
        description: {
          rendered: srcset,
        },
        // media_details: {
        //   sizes: srcset,
        // },
      }) {
        return {
          alt,
          src,
          srcset: this.cleanSrcset(srcset),
        };
      },
      async fetch() {
        const {
          alt,
          src,
          srcset,
        } = this.clean(await fetchImage(this.id));

        this.srcset = srcset;
        this.src = src;
        this.alt = alt;
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>

</style>
